import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xYTYzbXJ2MCB7CiAgd2lkdGg6IDlyZW07CiAgYWxpZ24tc2VsZjogc3RyZXRjaDsKfQ';
export var disabledDecimalsClass = '_1a63mrv0';